export const DROPDOWN_MENU_ERRORS = {
  REQUIRED: 'dropdownMenu.required',
};
